import { Component, OnInit, AfterViewInit, Input, ElementRef } from '@angular/core';
import {LoadStylesService} from '../../../../core/services/load-styles/load-styles.service';
import '../../../../../assets/vendor/fancybox/jquery.fancybox.min.js';
import '../../../../../assets/js/components/hs.fancybox.js';
import { Guid } from '../../../../guid';
import { PhotoGallerySettings } from './fancy-photo-classes';

declare var $: any;

@Component({
  selector: 'app-fancy-photo-gallery',
  templateUrl: './fancy-photo-gallery.component.html',
  styleUrls: ['./fancy-photo-gallery.component.css']
})

export class FancyPhotoGalleryComponent implements OnInit, AfterViewInit {

  // metadata for the photos in the gallery.
  @Input() photoGallery: PhotoGallerySettings;

  // if mosaic, image thumbnails are displayed in dramatic fashion
  // NOTE: mosaic must have at least 4 photos to function!
  @Input() mosaic: boolean;

  // how many thumbnails to show on the content page.
  @Input() thumbnailCount: number;

  @Input() clsPlaceholderHeight: string;

  // unique identifier for this gallery
  // (so photos don't get grouped together from different pages.)
  imageGalleryName: string;

  constructor(private elementRef: ElementRef, private loadStylesService: LoadStylesService) {
    this.mosaic = false;
  }

  ngOnInit() {
    this.loadStylesService.loadStyle("fancybox-bundle");

    const innerWidth = window.innerWidth;
    this.updateThumbnailCount(innerWidth);
    this.imageGalleryName = Guid.newGuid();

    this.elementRef.nativeElement.addEventListener('click', () => {
      this.openGallery();
    });
  }

  openGallery() {
    const fancyboxElement = document.querySelector('.js-fancybox-' + this.imageGalleryName);
    const htmlElement = (fancyboxElement as HTMLElement);
    if (htmlElement) {
      htmlElement.click();
    }
  }

  // NOTE: fancybox needs to be initialized in ngAfterViewInit,
  // as we need to wait for the dynamic content to be generated via ngFor* in the HTML.
  ngAfterViewInit() {
    // the "padded" bit is only needed if thumb gallery is shown.
    // in a 1-photo gallery, there is no need for the thumb gallery.
    const showThumbs = this.photoGallery && this.photoGallery.photos && this.photoGallery.photos.length > 1;
    const baseClassStr = showThumbs ? 'u-fancybox-theme u-fancybox-theme-padded' : 'u-fancybox-theme';
    const baseTplStr =
        '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-content">' +
        '<div class="fancybox-toolbar">{{BUTTONS}}</div>' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-controls" style="position: relative; z-index: 99999;">' +
        '<div class="fancybox-infobar">' +
        '<div class="fancybox-infobar__body">' +
        '<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="fancybox-slider-wrap">' +
        // only show Next & Previous arrows if there are multiple photos
        (showThumbs ?
        ('<button data-fancybox-prev class="fancybox-arrow fancybox-arrow--left" title="Previous"></button>' +
        '<button data-fancybox-next class="fancybox-arrow fancybox-arrow--right" title="Next"></button>')
        : '') +
        '<div class="fancybox-stage"></div>' +
        '</div>' +
        '<div class="fancybox-caption-wrap">' +
        '<div class="fancybox-caption"></div>' +
        '</div>' +
        '</div>' +
        '</div>';

    // initialization of fancybox
    $.HSCore.components.HSFancyBox.init('.js-fancybox-' + this.imageGalleryName, {
      parentEl: 'html',
      baseClass: baseClassStr,
      slideClass: 'u-fancybox-slide',
      speed: 1000,
      slideSpeedCoefficient: 1,
      infobar: false,
      toolbar: true,
      idleTime: false,
      closeExisting: true,
      fullScreen: true,
      arrows: showThumbs,
      keyboard: showThumbs,
      touch: showThumbs,
      thumbs : { autoStart : showThumbs },
      buttons: [
        'close'
      ],
      clickContent: (current: any) => {
        return current.type === 'image' ? 'zoom' : false;
      },
      closeBtn: true,
      baseTpl: baseTplStr,
      animationEffect: 'fade',
      transitionEffect: 'slide'
    });
  }

  updateThumbnailCount(width: number) {
    if (this.mosaic) {
      this.thumbnailCount = 4;
      return;
    }
    if (this.thumbnailCount === undefined) {
      if (width < 768) {
        // xs & sm
        this.thumbnailCount = 1;
      } else if (width >= 768 && width <= 992) {
        // md
        this.thumbnailCount = 2;
      } else if (width > 992 && width <= 1200) {
        // lg
        this.thumbnailCount = 3;
      } else {
        // xl
        this.thumbnailCount = 3;
      }
    }
  }
}
